var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-unlock"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-unlock",
    clipPath: "url(#clip-icon-unlock)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M463.876,325.765c-.147,3.428-.215,6.856-.215,10.306V325.765Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M964.244,332.168a250.305,250.305,0,0,0-500.368-6.4c-.147,3.428-.215,6.856-.215,10.306V458.884H172.106A113.256,113.256,0,0,0,58.978,572.012V825.341A113.257,113.257,0,0,0,172.106,938.47H743.078A113.257,113.257,0,0,0,856.206,825.341V572.012A113.256,113.256,0,0,0,743.078,458.884H527.013V336.071c0-103.082,83.863-186.956,186.957-186.956s186.956,83.874,186.956,186.956V445.817a31.676,31.676,0,1,0,63.352,0V336.071Q964.278,334.119,964.244,332.168ZM743.078,522.236a49.827,49.827,0,0,1,49.776,49.776V825.341a49.828,49.828,0,0,1-49.776,49.777H172.106a49.828,49.828,0,0,1-49.776-49.777V572.012a49.827,49.827,0,0,1,49.776-49.776Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M769.185,269.937q-.22,5.142-.215,10.317V269.937Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 63.352,
    height: 193.007,
    rx: 31.676,
    transform: "translate(425.916 602.174)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.83fa0ed1f37f258efcb6e3743cd6cd78.svg";
export { ForwardRef as ReactComponent };